import { useFormik } from 'formik'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup';
import { useTokenCallback } from '../../../../utils/hooks/useTokenCallback'
import { SeeCategories } from '../../../actions/pCategoriesActions'
import { getProduct, SeeProductsPresentations, updateProduct } from '../../../actions/productActions'
import { SeeSubCategories, SeeSubCategoriesById } from '../../../actions/subCategoriesActions'
import ProductCreate from '../../../containers/Inventory/Products/ProductCreate/ProductCreate'
const ProductEdit = ({match,history}) => {
    const dispatch = useDispatch()
    const { product,presentations } = useSelector(state => state.productsList)
    const { isLoadingCategoriesList, categoriesList } = useSelector(state => state.categoriesAdmin)
    const { isLoadingSubCategoriesList, subCategoriesList } = useSelector(state => state.subCategoriesAdmin)

    const validationSchema = Yup.object().shape({
        code: Yup.string().required('Requerido'),
        name: Yup.string().required('Requerido'),
        categoryId: Yup.string().required('Requerido'),
        subcategoryId: Yup.string().required('Requerido'),
        description: Yup.string().required('Requerido'),
        presentationId: Yup.string().required('Requerido'),
        price: Yup.number().positive("no puede ser negativo").required('Requerido'),
        productCost: Yup.number().positive("no puede ser negativo").required('Requerido'),
      });
      
    const formik = useFormik({
        enableReinitialize:true,
        initialValues: {
            code: product?.code || "",
            categoryId: product?.categoryId?._id || "",
            subcategoryId:  product?.subcategoryId?._id || "",
            name:  product?.name || "",
            description:  product?.description || "",
            price: product?.price || "",
            productCost: product?.productCost || "",
            presentationId: product?.presentationId?._id  || "",
        },
        validationSchema:validationSchema,
        onSubmit:(values=>{
            const formData = new FormData()
            for (var key in values) {
                if (key === "image" && values[key] === "") {

                } else {
                    formData.append(key, values[key]);
                }
            }
            dispatch(updateProduct(formData,match.params.idProduct,history))
            
        })
    })
    useTokenCallback(() => {
        dispatch(getProduct(match.params.idProduct))
    }, [match.params.idProduct])
    useTokenCallback(() => {
        dispatch(SeeCategories())
        dispatch(SeeProductsPresentations())
    }, [])
    
    useTokenCallback(() => {
        dispatch(SeeSubCategoriesById(formik.values.categoryId))
    }, [formik.values.categoryId])
    return (
        <ProductCreate formik={formik} categories={categoriesList}  product={product} subCategories ={subCategoriesList}  presentations={presentations} isEdit/>
    )
}

export default ProductEdit